import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import UuidEncoder from 'uuid-encoder';
import { AppComponent } from 'src/app/app.component';
import { ImagePreloadService } from './preload-images.service';

// Create Base 36 encoder
const encoder = new UuidEncoder('base36');

@Injectable({
    providedIn: 'root'
})
export class UtilsService {

    private loading = new BehaviorSubject<any>(false);
    private WarningsSpaces = new BehaviorSubject<number>(0);

    constructor(private preload: ImagePreloadService) { }

    setLoading(b: any) {
        this.loading.next(b);
    }

    getLoading() {
        return this.loading.asObservable();
    }

    setWarningsSpaces(b: number) {
        this.WarningsSpaces.next(b);
    }

    getWarningsSpaces() {
        return this.WarningsSpaces.asObservable();
    }

    public uuidv4() {
        return encoder.encode(this.uuidv4Aux());
    }

    uuidv4Aux() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = (Math.random() * 16) | 0,
                v = c == 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }

    formatDate(date: string) {
        if(date) {
            let arr = date.split('/');
            if(arr[2]) {
                return arr[2] + '-' + arr[1] + '-' + arr[0];
            }
            return date;
        } else {
            return date;
        }

    }

    sleep(ms: number): Promise<void> {
      return new Promise(resolve => setTimeout(resolve, ms));
    }

    async preloadImages(flowConfig, funderStyles) {
      return new Promise(async (resolve) => {
        let arrayImages = [];
        if(flowConfig?.texts?.form?.customImage) {
          arrayImages.push(flowConfig?.texts?.form?.customImage)
        }
        if(funderStyles?.withLogo && funderStyles?.logoUrl) {
          arrayImages.push(funderStyles.logoUrl)
        }

        this.preload.preload(arrayImages).then(async () => {
            await this.sleep(200);
            resolve(true);
          }).catch(async e => {
            await this.sleep(200);
            resolve(true);
          })
      })
    }
}
